import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesOrderLine, SalesOrderLineCreate, SalesOrderLineFilter } from '../data/salesOrderLine';

export function createSalesOrderLineService(client: AxiosInstance) {
  return createCrudService<SalesOrderLine, SalesOrderLineCreate, SalesOrderLineFilter>(
    client,
    '/sales/SalesOrderLine',
    'id',
  );
}

export type SalesOrderLineService = CrudService<SalesOrderLine, SalesOrderLineCreate, SalesOrderLineFilter>;
